import React from 'react';
import './PeopleSection.css';
import { useNavigate } from 'react-router-dom';

const PeopleSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/careers');
  };

  return (
    <div className="people-container">
      <div className="people-image">
        <img
          src="https://img.freepik.com/premium-photo/meeting-teamwork-business-people-office-laughing-talking-conversation-collaboration-comic-smile-happy-group-employees-friends-women-discussing-sales-project-workplace_590464-160337.jpg"
          alt="Team members talking"
        />
      </div>
      <div className="people-content">
        <div className="section-title">
          <span className="title-highlight">People</span>
          <div className="subline-container">
            <div className="line"></div>
          <span className="title-subline">at the <br className="mobile-break" />Software</span>
          </div>
        </div>
        <p>
          At Adithya Infinity, our people are the foundation of everything we do. 
          We value collaboration, diversity, and innovation, creating an environment 
          where every individual feels empowered to grow. Our strength lies in nurturing 
          talent and providing opportunities that help professionals unlock their true 
          potential while driving success for our clients across IT and Non-IT industries.
        </p>
        <button className="cta-button" onClick={handleClick}>Join Us →</button>
      </div>
    </div>
  );
};

export default PeopleSection;
